var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _ellipse, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCftLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 100,
    viewBox: "0 0 93 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.9223 60.5097L85.5417 81.5288L65.8624 84.5543L45.707 45.5415L87.9223 60.5097Z",
    fill: "url(#paint0_linear_306_9388)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8691 69.1081L49.5144 48.5667L44.5946 90.9234L19.678 89.1718L15.8691 69.1081Z",
    fill: "url(#paint1_linear_306_9388)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3058 86.9425L53.8006 99.9999L37.1367 89.0126L49.0395 51.9106L70.3058 86.9425Z",
    fill: "url(#paint2_linear_306_9388)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7799 27.3887L42.8496 44.9046L82.3669 60.9874L93.0001 44.9046L80.7799 27.3887Z",
    fill: "url(#paint3_linear_306_9388)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.707 45.7006L55.3475 8.59863L76.4909 10.8798L79.9871 31.573L45.707 45.7006Z",
    fill: "url(#paint4_linear_306_9388)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4176 18.9557L41.5712 4.40355L24.2507 16.3698L46.051 58.2033L59.4176 18.9557Z",
    fill: "url(#paint5_linear_306_9388)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2345 20.7007L7.55834 24.5393L5.07812 45.4919L50.7849 56.688L30.2345 20.7007Z",
    fill: "url(#paint6_linear_306_9388)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0 58.0571L12.8969 41.4014L49.6444 54.2135L13.957 75.1932L0 58.0571Z",
    fill: "url(#paint7_linear_306_9388)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_306_9388",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 39,
    width: 43,
    height: 19
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6269 57.1657L8.57031 46.4969L12.3792 39.3313L49.0398 45.7007L50.6269 57.1657Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_306_9388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 58.0576L12.8969 41.4019L49.6444 54.2139L13.957 75.1937L0 58.0576Z",
    fill: "url(#paint8_linear_306_9388)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.5631,
    cy: 51.9109,
    rx: 19.3619,
    ry: 19.4268,
    fill: "url(#paint9_radial_306_9388)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M47.048 26.5011C17.0529 20.4501 13.2439 55.3228 39.1125 55.9598H77.0429",
    stroke: "#2D3691",
    strokeWidth: 4.29927
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2838 40.5139H42.2871V71.7242",
    stroke: "#2D3691",
    strokeWidth: 4.29927
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3477 83.03V56.1191",
    stroke: "#2D3691",
    strokeWidth: 4.29927
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_9388",
    x1: 83.796,
    y1: 56.5288,
    x2: 52.2026,
    y2: 76.1868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802355,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_9388",
    x1: 48.5621,
    y1: 78.503,
    x2: 34.3545,
    y2: 49.9563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738068,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_9388",
    x1: 68.5601,
    y1: 78.3438,
    x2: 36.3132,
    y2: 66.0022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802355,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_306_9388",
    x1: 69.4935,
    y1: 27.3887,
    x2: 81.25,
    y2: 62.5468,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802355,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_306_9388",
    x1: 63.0058,
    y1: 8.59863,
    x2: 80.4989,
    y2: 42.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802355,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_306_9388",
    x1: 23.4147,
    y1: 27.2849,
    x2: 68.2796,
    y2: 31.1603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802355,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_306_9388",
    x1: 12.6959,
    y1: 53.3292,
    x2: 45.3431,
    y2: 22.2097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802355,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_306_9388",
    x1: 45.2276,
    y1: 64.9436,
    x2: 43.1627,
    y2: 38.1222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821737,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_306_9388",
    x1: 45.2276,
    y1: 64.9441,
    x2: 43.1627,
    y2: 38.1227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5942D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535036,
    stopColor: "#FDC58D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.821737,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_306_9388",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.563 54.8789) rotate(90) scale(18.3696 18.3083)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCBF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#FCBF80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDC287",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCftLogo);
export default __webpack_public_path__ + "static/media/cftLogo.d99a497c2eac3b747dd362e8ced29695.svg";
export { ForwardRef as ReactComponent };